<template>
  <section class="dialog-container">
    <close-button @click="onCancel" class="close-button"></close-button>
    <header class="dialog-header">
      <h1>{{ title }}</h1>
    </header>
    <main class="dialog-content">
      <ul>
        <folder-leaf
          v-for="(leaf, index) in tree"
          :key="index"
          :folder="leaf"
          :expanded="true"
          :root="true"
        ></folder-leaf>
      </ul>
    </main>
    <div class="dialog-footer">
      <section>
        <button
          v-if="canAdd"
          class="pill-button"
          @click="addFolder()"
          :disabled="!selectedId"
        >
          nieuwe map
        </button>
      </section>
      <section>
        <button class="pill-button secondary" @click="onCancel">
          Annuleren
        </button>
        <button
          class="pill-button"
          :disabled="!selectedId"
          @click="triggerCallback"
        >
          {{ actionLabel }}
        </button>
      </section>
    </div>
  </section>
</template>

<script>
import FolderLeaf from '@/features/filestore/dialogs/FolderLeaf.vue'
import NameDialog from '@/features/filestore/dialogs/NameDialog.vue'
import * as fileStoreService from '@/features/filestore/FileStoreService.js'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  props: [
    'name',
    'title',
    'actionLabel',
    'callback',
    'cancelCallback',
    'archiveId',
    'canAdd'
  ],
  components: { FolderLeaf },
  name: 'FolderTreeBrowser',
  unmounted() {
    // Clear possible dangling state in the store
    this.fileStoreStore.treeBrowserSelectedFolderId = null
  },
  mounted() {
    // this.$nextTick(() => this.$forceUpdate())
  },
  computed: {
    ...mapStores({ fileStoreStore: useFileStoreStore }),
    tree() {
      if (this.archiveId) {
        return this.fileStoreStore.getFolderTreeForArchive(this.archiveId)
      } else {
        return this.fileStoreStore.getFolderTree
      }
    },
    selectedId() {
      return this.fileStoreStore.treeBrowserSelectedFolderId
    }
  },
  methods: {
    addFolder() {
      this.$modal.show(
        NameDialog,
        {
          name: '',
          title: 'Nieuwe map',
          actionLabel: 'Voeg toe',
          callback: (name) => {
            fileStoreService.addFolder(this.selectedId, name).then((folder) => {
              this.fileStoreStore.treeBrowserSelectedFolderId = folder.folderId
            })
          }
        },
        { width: 300, height: 'auto' }
      )
    },
    onCancel() {
      if (this.cancelCallback) {
        this.cancelCallback()
      }
      this.$emit('close')
    },
    triggerCallback() {
      const folder = this.fileStoreStore.getFolder(
        this.fileStoreStore.treeBrowserSelectedFolderId
      )
      this.callback(folder)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  //padding: 25px;
  display: grid;
  grid-template-rows: 49px auto 50px;
  height: 100%;

  .dialog-header {
    padding-bottom: 10px;
  }

  .dialog-content {
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 10px;
  }

  .dialog-footer {
    display: flex;
    padding-left: 15px;
    padding-right: 25px;
    justify-content: space-between;

    button {
      margin-left: 10px;
    }
  }
}
</style>
